import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { NavLink } from "react-router-dom";


const ButtonTemplate = styled(
    ({ children, className, ...rest }) => {
        let NodeType = 'button'

        if (!!rest.to && !rest.disabled) {
            if (rest.to.substr(0, 4) === 'http') {
                NodeType = 'a'
                rest.href = rest.to
                delete rest.to
            } else {
                NodeType = NavLink
            }
        } else {
            NodeType = 'button'

            if (!!rest.disabled) {
                delete rest.to
            }
        }

        // make sure all children are wrapped in a node
        const warppedChildren = React.Children.map(children, child => typeof child === 'string' ? <span>{child}</span> : child)

        return <NodeType
            className={`button ${className}`}
            {...rest}
        >
            {warppedChildren}
        </NodeType>

    })`
    cursor: pointer;
	position: relative;
    display: flex;
    
    
    `

const Button = styled(
    ({ children, ...props }) => <ButtonTemplate {...props}>{children}</ButtonTemplate>)
    `
        border: 1px solid rgba(255,255,255,0.3);
        color: var(--button--text--color, white);
        background: var(--button--background--color, transparent);
    
        &:hover{
            border: 1px solid var(--button--border--color, white);
        }
        `
Button.Full = styled(
    ({ children, ...props }) => <ButtonTemplate {...props}>{children}</ButtonTemplate>)
    `
        display: block;
        width: 100%;    
        border: 1px solid var(--button-primary--border--color, transparent);
        border-radius: 4px;
        color: var(--button-primary--text--color, black);
        background: var(--button-primary--background--color, green);
        padding: 10px;
        text-align: center;
        
        &:not([disabled]):hover{
            background: var(--button-primary--background--color--hover, white);
            border: 1px solid var(--button-primary--border--color--hover, transparent);
        }
        `


export default Button